interface CarouselItem {
  title: string;
  tag: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '2024 年度电影盛典回顾',
    tag: '年度盘点',
    desc: '回顾2024年华语电影的高光时刻，从春节档票房奇迹到暑期档口碑佳作，盘点那些让我们欢笑与感动的银幕记忆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20movie%20awards%20ceremony%20stage%20with%20golden%20trophies%20and%20red%20carpet%2C%20warm%20theatrical%20lighting%2C%20elegant%20cinema%20atmosphere%2C%20Hollywood-style%20glamour%2C%20professional%20event%20photography%2C%20rich%20gold%20and%20crimson%20tones&width=1200&height=500&seq=carousel-1-wuma&orientation=landscape',
    imageAlt: '2024年度电影盛典回顾专题',
  },
  {
    title: '暑期档观影指南',
    tag: '观影指南',
    desc: '今夏必看的十部新片全解析，动作、喜剧、动画一网打尽，帮你合理安排暑期观影计划',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20exterior%20with%20bright%20sunlight%20and%20colorful%20movie%20posters%2C%20lively%20atmosphere%2C%20warm%20summer%20vibes%2C%20people%20enjoying%20cinema%2C%20professional%20photography%2C%20vibrant%20and%20cheerful%20aesthetic&width=1200&height=500&seq=carousel-2-wuma&orientation=landscape',
    imageAlt: '暑期档观影指南专题',
  },
  {
    title: '华语科幻电影崛起之路',
    tag: '深度观察',
    desc: '从《流浪地球》到《宇宙探索编辑部》，华语科幻电影如何用东方叙事改写世界科幻版图',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20cityscape%20with%20floating%20structures%20and%20neon%20accents%2C%20warm%20golden%20and%20red%20lighting%2C%20sci-fi%20aesthetic%20with%20traditional%20Chinese%20architectural%20elements%2C%20cinematic%20wide%20shot%2C%20professional%20concept%20art&width=1200&height=500&seq=carousel-3-wuma&orientation=landscape',
    imageAlt: '华语科幻电影崛起之路专题',
  },
  {
    title: '经典港片修复计划',
    tag: '经典重现',
    desc: '午马影院联合多家片方启动经典港片4K修复计划，王家卫、吴宇森代表作焕新归来',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20city%20street%20at%20night%20with%20neon%20signs%20and%20wet%20pavement%2C%20nostalgic%20cinematic%20aesthetic%2C%20warm%20red%20and%20gold%20neon%20glow%2C%20film%20noir%20style%2C%20atmospheric%20photography%2C%20rich%20contrast%20and%20mood&width=1200&height=500&seq=carousel-4-wuma&orientation=landscape',
    imageAlt: '经典港片修复计划专题',
  },
  {
    title: '女性导演作品专题',
    tag: '特别企划',
    desc: '聚焦当代华语女性导演的创作力量，从贾玲到邵艺辉，她们用镜头讲述不一样的故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20film%20director%20workspace%20with%20movie%20storyboards%20on%20wall%2C%20soft%20warm%20lighting%2C%20creative%20atmosphere%2C%20professional%20filmmaking%20environment%2C%20artistic%20composition%2C%20cinematic%20behind-the-scenes%20photography&width=1200&height=500&seq=carousel-5-wuma&orientation=landscape',
    imageAlt: '女性导演作品专题企划',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              深度策划的电影专题内容，带你从不同视角发现电影世界的精彩
            </p>
          </div>
          <div className="flex flex-col gap-5">
            {carouselItems.map((item, idx) => (
              <div
                key={idx}
                className="group flex flex-col md:flex-row rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="md:w-2/5 lg:w-1/3 h-48 md:h-auto overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium w-fit mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}